import type { SoftReloadPreset } from './softReloadPresets';
import {
  restartFullLaunchMountVitals,
  restartSoftReloadVitals,
  type SoftReloadMountVital,
} from '@/utilities/logger/datadog/vitals';

/** Full game reset — relaunch FD launch, client load, and game-ready vitals. */
const FULL_LAUNCH_VITALS: SoftReloadMountVital[] = [
  'fdLaunch',
  'gameClient',
  'gameLaunch',
];

const SOFT_RELOAD_VITALS: Record<
  Exclude<SoftReloadPreset, 'logout'>,
  SoftReloadMountVital[]
> = {
  'iframe-only': FULL_LAUNCH_VITALS,
  'game-client-retry': FULL_LAUNCH_VITALS,
  'launch-new-game': FULL_LAUNCH_VITALS,
  'geolocation-retry': FULL_LAUNCH_VITALS,
  'jackpot-retry': ['gameClient'],
};

export const restartVitalsForSoftReloadPreset = (
  preset: Exclude<SoftReloadPreset, 'logout'>,
  options?: { fullLaunchRestart?: boolean },
) => {
  if (
    options?.fullLaunchRestart &&
    (preset === 'jackpot-retry' || preset === 'iframe-only')
  ) {
    restartFullLaunchMountVitals();
    return;
  }

  restartSoftReloadVitals(SOFT_RELOAD_VITALS[preset]);
};
